module.exports = __webpack_public_path__ + "static/media/icon_new-email.fb66909a.svg";